import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, CardTitle, Button, Input, InputGroup } from "reactstrap";
import "./ProductCard.css";

const featureIcons = {
  cpu: "fa-microchip",
  gpu: "fa-memory",
  storage: "fa-hard-drive",
  network: "fa-network-wired",
  bandwidth: "fa-database",
  uptime: "fa-chart-line",
  default: "fa-check",
};

const getFeatureIcon = (feature) => {
  const lower = feature.toLowerCase();
  if (lower.includes("cpu") || lower.includes("core")) return featureIcons.cpu;
  if (lower.includes("gpu")) return featureIcons.gpu;
  if (lower.includes("ssd") || lower.includes("nvme") || lower.includes("storage")) return featureIcons.storage;
  if (lower.includes("network") || lower.includes("mbps")) return featureIcons.network;
  if (lower.includes("bandwidth")) return featureIcons.bandwidth;
  if (lower.includes("uptime") || lower.includes("97%")) return featureIcons.uptime;
  return featureIcons.default;
};

const ProductCard = ({ product }) => {
  const [quantity, setQuantity] = useState(1);
  const navigate = useNavigate();

  const isTrialOnly = product.trialOnly === true;
  const gbp = (n) => `£${Number(n).toFixed(2)}`;
  const priceDisplay = isTrialOnly
    ? `${gbp(10)} / month after trial`
    : product.period
      ? `${gbp(product.price)} / month`
      : gbp(product.price);

  const handlePurchase = () => {
    const params = new URLSearchParams({ product: product.id });
    if (product.hasQuantity) params.set("quantity", String(quantity));
    navigate(`/payment?${params.toString()}`);
  };

  const handleTrialDownload = () => {
    const url = product.trialDownloadUrl || (product.id === "remote-desktop" ? process.env.REACT_APP_REMOTE_DESKTOP_TRIAL_URL : "") || "";
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Card className="hn-product-card h-100">
      <CardBody className="d-flex flex-column">
        <div className="hn-product-card-header">
          {product.bestFor && (
            <span className="hn-product-badge">{product.bestFor}</span>
          )}
          <CardTitle tag="h5" className="hn-product-title">
            {product.name}
          </CardTitle>
        </div>
        <p className="hn-product-price">{priceDisplay}</p>
        <p className="hn-product-guarantee small text-muted mb-2">
          <i className="fas fa-shield-halved me-1" aria-hidden="true" />
          97% uptime target · Money-back within 3 days if not yet deployed
        </p>
        <ul className="hn-product-features list-unstyled">
          {product.features.map((feature, idx) => (
            <li key={idx} className="d-flex align-items-start gap-2">
              <i
                className={`fas ${getFeatureIcon(feature)} hn-feature-icon mt-1`}
                aria-hidden="true"
              />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
        <div className="mt-auto pt-3">
          {!isTrialOnly && product.hasQuantity && (
            <InputGroup className="mb-2">
              <span className="input-group-text">Quantity</span>
              <Input
                type="number"
                min={1}
                value={quantity}
                onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value, 10) || 1))}
              />
            </InputGroup>
          )}
          {isTrialOnly ? (
            <Button
              color="warning"
              className="hn-purchase-btn w-100"
              onClick={handleTrialDownload}
            >
              Download trial
            </Button>
          ) : (
            <Button color="warning" className="hn-purchase-btn w-100" onClick={handlePurchase}>
              Purchase
            </Button>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default ProductCard;
